const mousetrap = require("mousetrap")
require("mousetrap/plugins/pause/mousetrap-pause")

const vueMousetrap = {
  install: function (Vue) {
    Vue.prototype.$mousetrap = mousetrap
  }
}

export default vueMousetrap